export class TranslationDto<T = string> {
  en: T
  kh: T

  public static create(en?: any, kh? : any) {
    const translation = new TranslationDto()

    translation.en = en || ''
    translation.kh = kh || ''

    return translation
  }
}
